import { Box } from "@mui/material";

export function AnuncioCard({
  children,
  highlighted = false,
}: {
  children: React.ReactNode;
  highlighted?: boolean;
}) {
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 3,
        overflow: "hidden",
        width: "100%",
        minHeight: { xs: "auto", sm: 600 },
        flex: "0 0 auto",
        borderColor: highlighted ? "primary.main" : "divider",
        boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
        display: "flex",
        flexDirection: "column",
        transition: "all .3s ease",
        "&:hover": {
          borderColor: "primary.main",
          transform: "translateY(-4px)",
        },
      }}
    >
      {children}
    </Box>
  );
}
